/**
 * Vuikit 0.8.10
 * (c) 2018 Miljan Aleksic
 * @license MIT
**/

/* Substantial part of the code is adapted from UIkit,
  Copyright (c) 2013-2018 YOOtheme GmbH, getuikit.com */

import { on, off } from '../util/event';

var events = {
  methods: {
    on: function on$1 () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      this._vk_events_off.push(on.apply(void 0, args));
    },
    off: function off$1 () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
      off.apply(void 0, args);
    }
  },
  created: function created () {
    this._vk_events_off = [];
  },
  beforeDestroy: function beforeDestroy () {
    this._vk_events_off.forEach(function (off$$1) { return off$$1(); });
  }
}

export default events;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuikit/lib/mixins/events.js
// module id = 2119
// module chunks = 0